<template>
	<div>
		<span class="int_type_no_border">
			<CodeSelect
				class="mgr_5"
				v-model.trim="selected_code"
				:codes="codes"
				:width="width"
				:className="className"
				:codeWidth="codeWidth"
				:nameWidth="nameWidth"
				:descWidth="descWidth"
				:disabled="disabled"
				:displayName="displayName"
				:displayDescription="displayDescription"
				:showDesc="showDesc"
				:excludeCode="excludeCode"
				:codeBold="codeBold"
				:descBold="descBold"
				:fontColor="fontColor"
			/>
		</span>
		<input type="text" class="tbl_int" :value="value" :disabled="disabled" autocomplete="off" :style="{ width: selectedCodesWidth + 'px' }" @input="updateValueStr" @blur="blur" @focus="$event.target.select()" @keydown.enter="enterEvent" />
	</div>
</template>

<script>
import CodeSelect from '@/components/common/CodeSelect';
export default {
	data: () => ({
		selected_code: '',
	}),
	components: {
		CodeSelect,
	},
	watch: {
		selected_code: {
			handler() {
				if (this.selected_code) this.renewValuesStr();
			},
		},
	},
	props: {
		value: String,
		codes: Array,
		separator: {
			type: String,
			default: ',',
		},
		width: {
			type: Number,
			default: 80,
		},
		className: String,
		codeWidth: {
			type: Number,
			default: 80,
		},
		nameWidth: {
			type: Number,
			default: 200,
		},
		descWidth: {
			type: Number,
			default: 150,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		displayName: {
			type: Boolean,
			default: true,
		},
		displayDescription: {
			type: Boolean,
			default: false,
		},
		showDesc: {
			type: Boolean,
			default: true,
		},
		excludeCode: {
			type: String,
			default: null,
		},
		codeBold: {
			type: Boolean,
			default: false,
		},
		descBold: {
			type: Boolean,
			default: false,
		},
		fontColor: {
			type: String,
			default: 'black',
		},
		selectedCodesWidth: {
			type: Number,
			default: 300,
		},
	},
	methods: {
		renewValuesStr() {
			let values_str = this.arrangeValuesStr(this.value, false);

			if (values_str && values_str.split(this.separator).some(el => el === this.selected_code)) this.$toast.error('Already Selected');
			else values_str += values_str ? this.separator + this.selected_code : this.selected_code;

			this.selected_code = '';
			this.$emit('input', values_str);
		},
		arrangeValuesStr(str, check_duplicated) {
			if (!str || !str.trim()) return '';

			let value_arr = str.split(this.separator);
			let values_str = '';

			if (check_duplicated) {
				for (let i = 0; i < value_arr.length; i++) {
					for (let j = i + 1; j < value_arr.length; j++) {
						if (value_arr[i].trim() === value_arr[j].trim()) {
							value_arr.splice(j, 1);
							j--;
						}
					}
				}
			}

			value_arr.forEach(el => {
				el = el.trim();
				if (el) values_str += values_str ? this.separator + el : el;
			});

			return values_str;
		},
		blur(event) {
			let values_str = this.arrangeValuesStr(event.target.value, true);
			this.$emit('input', values_str);
			event.target.value = values_str;
		},
		updateValueStr(event) {
			this.$emit('input', event.target.value);
		},
		enterEvent() {
			this.$emit('keydown');
		},
	},
};
</script>

<style></style>
